import { render } from "./settings-controllers-MaxAutarchy.vue?vue&type=template&id=eb2293a4"
import script from "./settings-controllers-MaxAutarchy.vue?vue&type=script&lang=js"
export * from "./settings-controllers-MaxAutarchy.vue?vue&type=script&lang=js"

import "./settings-controllers-MaxAutarchy.vue?vue&type=style&index=0&id=eb2293a4&lang=css"

import exportComponent from "C:\\Users\\Usuario\\Documents\\Git-Repositorios\\edge_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__